export default "__VITE_ASSET__vBtHr7BRaOJuicxr4F1qBQ__"